export const localeConfig = {
  th: { 
    name: 'ไทย', 
    nativeName: 'ไทย', 
    code: 'TH',
    rtl: false, 
    flag: '🇹🇭' 
  },
  en: { 
    name: 'English', 
    nativeName: 'English', 
    code: 'EN',
    rtl: false, 
    flag: '🇬🇧' 
  },
  de: { 
    name: 'Deutsch', 
    nativeName: 'Deutsch', 
    code: 'DE',
    rtl: false, 
    flag: '🇩🇪' 
  },
  fr: { 
    name: 'Français', 
    nativeName: 'Français', 
    code: 'FR',
    rtl: false, 
    flag: '🇫🇷' 
  },
  ru: { 
    name: 'Русский', 
    nativeName: 'Русский', 
    code: 'RU',
    rtl: false, 
    flag: '🇷🇺' 
  },
  'zh-CN': { 
    name: '中文', 
    nativeName: '中文 (简体)', 
    code: 'CN',
    rtl: false, 
    flag: '🇨🇳' 
  },
  'zh-TW': { 
    name: '中文', 
    nativeName: '中文 (繁體)', 
    code: 'TW',
    rtl: false, 
    flag: '🇹🇼' 
  },
  ko: { 
    name: '한국어', 
    nativeName: '한국어', 
    code: 'KR',
    rtl: false, 
    flag: '🇰🇷' 
  },
  ja: { 
    name: '日本語', 
    nativeName: '日本語', 
    code: 'JP',
    rtl: false, 
    flag: '🇯🇵' 
  },
  ar: { 
    name: 'العربية', 
    nativeName: 'العربية', 
    code: 'AR',
    rtl: true, 
    flag: '🇸🇦' 
  },
};

export const supportedLanguages = Object.keys(localeConfig);

